import type { Plan, PlanComparisonGroup, PlanComparisonRow } from "./types.js";

/**
 * Structured feature matrix for Basic vs Premium comparison tables.
 * Labels and formatted values are resolved via i18n on the client.
 */
export const PLAN_COMPARISON_GROUPS: PlanComparisonGroup[] = [
  "contentVolume",
  "productionAutomation",
  "advancedFormats",
  "guarantee",
];

export const PLAN_COMPARISON_ROWS: PlanComparisonRow[] = [
  {
    id: "instagramAccounts",
    group: "contentVolume",
    labelKey: "planComparison.rows.instagramAccounts",
    displayType: "text",
    basic: { kind: "text", textKey: "planComparison.values.oneAccount" },
    premium: { kind: "text", textKey: "planComparison.values.oneAccount" },
  },
  {
    id: "feedPosts",
    group: "contentVolume",
    labelKey: "planComparison.rows.feedPosts",
    displayType: "limit",
    basic: { kind: "limit", value: 30 },
    premium: { kind: "unlimited" },
  },
  {
    id: "stories",
    group: "contentVolume",
    labelKey: "planComparison.rows.stories",
    displayType: "limit",
    basic: { kind: "limit", value: 30 },
    premium: { kind: "unlimited" },
  },
  {
    id: "carousels",
    group: "contentVolume",
    labelKey: "planComparison.rows.carousels",
    displayType: "limit",
    basic: { kind: "limit", value: 30 },
    premium: { kind: "unlimited" },
  },
  {
    id: "reels",
    group: "contentVolume",
    labelKey: "planComparison.rows.reels",
    displayType: "limit",
    basic: { kind: "excluded" },
    premium: { kind: "limit", value: 20 },
  },
  {
    id: "contentPlanner",
    group: "productionAutomation",
    labelKey: "planComparison.rows.contentPlanner",
    displayType: "boolean",
    basic: { kind: "included" },
    premium: { kind: "included" },
  },
  {
    id: "metaIntegration",
    group: "productionAutomation",
    labelKey: "planComparison.rows.metaIntegration",
    displayType: "boolean",
    basic: { kind: "included" },
    premium: { kind: "included" },
  },
  {
    id: "smartScheduling",
    group: "productionAutomation",
    labelKey: "planComparison.rows.smartScheduling",
    displayType: "boolean",
    basic: { kind: "included" },
    premium: { kind: "included" },
  },
  // Temporarily hidden — feature not shipping yet (same as PremiumScreen QA 14/07/2026).
  // {
  //   id: "whatsappAgent",
  //   group: "productionAutomation",
  //   labelKey: "planComparison.rows.whatsappAgent",
  //   displayType: "boolean",
  //   basic: { kind: "excluded" },
  //   premium: { kind: "included" },
  // },
  // Temporarily hidden from "Formatos avançados" — bring back in a few months.
  // {
  //   id: "storyCarousel",
  //   group: "advancedFormats",
  //   labelKey: "planComparison.rows.storyCarousel",
  //   displayType: "boolean",
  //   basic: { kind: "excluded" },
  //   premium: { kind: "included" },
  // },
  {
    id: "storyWithMusic",
    group: "advancedFormats",
    labelKey: "planComparison.rows.storyWithMusic",
    displayType: "boolean",
    basic: { kind: "excluded" },
    premium: { kind: "included" },
  },
  {
    id: "storyWithVideo",
    group: "advancedFormats",
    labelKey: "planComparison.rows.storyWithVideo",
    displayType: "boolean",
    basic: { kind: "excluded" },
    premium: { kind: "included" },
  },
  {
    id: "postWithMusic",
    group: "advancedFormats",
    labelKey: "planComparison.rows.postWithMusic",
    displayType: "boolean",
    basic: { kind: "excluded" },
    premium: { kind: "included" },
  },
  {
    id: "carouselWithMusic",
    group: "advancedFormats",
    labelKey: "planComparison.rows.carouselWithMusic",
    displayType: "boolean",
    basic: { kind: "excluded" },
    premium: { kind: "included" },
  },
  {
    id: "satisfactionGuarantee",
    group: "guarantee",
    labelKey: "planComparison.rows.satisfactionGuarantee",
    displayType: "boolean",
    basic: { kind: "included" },
    premium: { kind: "included" },
  },
];

export function getPlanComparisonRowsByGroup(group: PlanComparisonGroup): PlanComparisonRow[] {
  return PLAN_COMPARISON_ROWS.filter((row) => row.group === group);
}

export function getPlanComparisonValue(row: PlanComparisonRow, plan: Plan) {
  return plan === "basic" ? row.basic : row.premium;
}
